module.exports = __webpack_public_path__ + "img/calendario-3-5grade.7c77a548.png";